module.exports = __webpack_public_path__ + "media/images/light_grey_2_lines_vertical-3145484634af32da2f56e4ad73b570d5.svg";